import React from "react";
import { Component } from "react";
// import { TimeLine } from "views/profile/components/my-activities/components/TimeLine";
import TimeLine from "./components/TimeLine";
class Activities extends Component {
  render() {
    return (
      <div className="">
        <div className="lg:text-right md:text-right text-center mb-6 lg:mt-0 md:mt-0 mt-6">
          <button className="outline-button w-230px h-50px fsize16 font-semibold rounded-25px">
            SHOW PENDING
          </button>
        </div>

        <div>
          <div className="rounded-8px bgF7F7F7 activity-stripe-h lg:flex md:flex  justify-end lg:pr-8 md:pr-8">
            <div className="flex items-center lg:mr-4 justify-center">
              <p className="fsize14 font-semibold text-black mr-4">Filter by</p>
              <div class="form-group  modal-form-cs sm-w70per">
                <input
                  type="date"
                  placeholder="16-18 Jun 2021"
                  className="fsize14 h-36px"
                  value="16-18 Jun 2021"
                />
              </div>
            </div>
            <div className="lg:flex md:flex items-center">
              <div className="flex items-center justify-center  md:mt-0 lg:mt-0 mt-2">
                {" "}
                <div className="flex items-center addborder-select sm-activity-t lg:mr-8 md:mr-8">
                  <p className="fsize14 font-semibold text-black ">Sort by:</p>
                  <div class="form-group  border-none ">
                    <select className="select-dropdown-c fsize14 ">
                      <option value="Newest">Newest </option>
                      <option value="Newest">Newest</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="flex items-center lg:mt-0 md:mt-0 sm-75per justify-center mt-4">
                <p className="text053C6D fsize14 font-bold">ADD FILTER +</p>
              </div>
            </div>
          </div>

          <TimeLine />
        </div>
      </div>
    );
  }
}
export default Activities;
